export const NAME = 'name';
export const OWNER = 'owner';
export const PARTNER_COMPANY = 'partnerCompany';
export const CUSTOMER_COMPANY = 'customerCompany';
export const INVOICE_LEVEL = 'invoiceLevel';
export const IO_TYPE = 'ioType';
export const VAT_NUMBER = 'vatNumber';
export const TAX_ID = 'taxId';
export const CURRENCY = 'currency';
export const EXPENSE_TYPES = 'expenseTypes';
export const NETWORK = 'network';
export const PAYMENT_TERM = 'paymentTerm';
export const GDPR_START_DATE = 'gdprStartDate';
export const ADDRESS = 'address';
export const STREET_ADDRESS = 'streetAddress';
export const STREET_ADDRESS_2 = 'streetAddress2';
export const CITY = 'city';
export const REGION = 'region';
export const POSTAL_CODE = 'postalCode';
export const COUNTRY = 'country';
export const EMAIL = 'email';
export const MOBILE = 'mobile';
export const PHONE = 'phone';
export const SKYPE = 'skype';
export const CONTACT_PERSON = 'contactPerson';
export const FIRST_NAME = 'firstName';
export const LAST_NAME = 'lastName';
export const TIME_ZONE = 'timeZone';
export const DPA = 'dpa';
export const NDA = 'nda';
export const DPA_ID = 'id';
export const DPA_NAME = 'name';
export const DPA_PERIOD = 'period';
export const INVOICE_PROCESSING_RULE = 'invoiceProcessingRule';
